import { css } from '@emotion/react';
import { Skeleton } from 'components/common/skeleton';
import styled from 'types/theme.types';
import { BaseItemContainer, ItemText } from 'components/layout/navbar/navbar-panel.utils';
import { useNavbarCollapse } from 'components/layout/navbar/navbar-collapse-context';

const SKELETON_WIDTH = 60;
const SKELETON_HEIGHT = 14;

/**
 * The rail is dark in both colour modes, so the dark sweep is pinned rather than themed.
 *
 * Declarations must name the inner element: `styled(Skeleton.Input)` classes the `.ant-skeleton`
 * wrapper, while antd paints and sizes the `.ant-skeleton-input` inside it. Tripled because antd's
 * own shimmer selector weighs three classes.
 */
const darkRailShimmer = css`
  &&& {
    .ant-skeleton-avatar,
    .ant-skeleton-input {
      background: linear-gradient(
        90deg,
        var(--color-neutral-700) 25%,
        var(--color-neutral-650) 37%,
        var(--color-neutral-700) 63%
      );
    }
  }
`;

const StyledSkeletonInput = styled(Skeleton.Input)`
  &&& .ant-skeleton-input {
    width: ${SKELETON_WIDTH}px;
    height: ${SKELETON_HEIGHT}px;
    min-width: ${SKELETON_WIDTH}px;
  }

  ${darkRailShimmer}
`;

const StyledSkeletonAvatar = styled(Skeleton.Avatar)`
  ${darkRailShimmer}
`;

const NavbarMenuItemSkeleton = () => {
  const { isCollapsed } = useNavbarCollapse();
  return (
    <BaseItemContainer data-e2e="navbar-menu-item-skeleton">
      <StyledSkeletonAvatar size="small" shape="square" active />
      {!isCollapsed && <ItemText>{!isCollapsed && <StyledSkeletonInput size="small" active />}</ItemText>}
    </BaseItemContainer>
  );
};

export default NavbarMenuItemSkeleton;
